
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';


const Notice = () => {

    const [Heading, setHeading] = useState("");
   
    useEffect(() => {
        const url = "https://sbvmapi.uniservedata.in/api/content?pageName=Notices";
        GetData(url);
    }, [])

    const GetData = async (url) => {
        const res = await fetch(url);
        const data = await res.json();
        console.log(data.content_data);
        setHeading(data.content_data);
    }

    return (
        <>

<div className="news_section">
  <div className="container mark">
    <div className="row">
      <div className="col-lg-12">
        <div className="marquee-wrapper">
          <div className="marquee-content">
           {Heading.length > 0 &&
              Heading.map((link, i) => (
                <div key={i} style={{ marginBottom: "10px" }}>
                  <Link to={{ pathname: `../Notices/${link._id}` }} style={{ textDecoration: "none", color: "inherit" }}>
                    <h4 className="appoinment_textmark">{link.heading}</h4>
                  </Link>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
        </>
    );
}

export default Notice;